import styled from "styled-components";

export const StyledRegisterModal = styled.div`
  .auth-header-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    border: 0;
    border-radius: 8px;
    padding: 0 18px;
    white-space: nowrap;
    font-size: 14px;
    line-height: 1;
    font-weight: 800;
    letter-spacing: 0;
    cursor: pointer;
    transition: transform 0.18s ease, background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
  }

  .auth-header-button:hover {
    transform: translateY(-1px);
  }

  .auth-header-login {
    color: #eff7f1;
    background: transparent;
    margin-right: 10px;
  }

  .auth-header-login:hover {
    color: var(--crypto-green);
    background: rgba(89, 244, 119, 0.08);
  }

  .auth-header-register {
    color: #101722;
    background: linear-gradient(135deg, #70ff8b, #28d961);
    box-shadow:
      0 10px 20px rgba(22, 184, 87, 0.26),
      inset 0 1px 0 rgba(255, 255, 255, 0.44),
      inset 0 -3px 0 rgba(0, 0, 0, 0.18);
  }

  .auth-header-anonymous {
    color: #e9fff0;
    margin-left: 8px;
    background: rgba(89, 244, 119, 0.1);
    border: 1px solid rgba(89, 244, 119, 0.24);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
  }

  .auth-header-anonymous:hover {
    color: #101722;
    background: linear-gradient(135deg, #70ff8b, #28d961);
  }

  .auth-modal-shell {
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 620px) minmax(320px, 1fr);
    height: min(690px, calc(100vh - 48px));
    min-height: 0;
    max-height: calc(100vh - 48px);
    width: 100%;
    overflow: hidden;
    border-radius: 10px;
    background: #181d29;
    transition: box-shadow 0.22s ease;
  }

  .auth-modal-shell.is-login .auth-form-transition {
    max-width: 430px;
  }

  .auth-modal-shell.is-login .auth-form-panel {
    display: flex;
    flex-direction: column;
  }

  .auth-modal-shell.is-login .auth-tab-row {
    display: grid;
    width: 430px;
    max-width: 100%;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 4px;
    padding: 4px;
    margin-bottom: 28px;
    border-radius: 8px;
  }

  .auth-modal-shell.is-login .auth-tab {
    min-width: 0;
    height: 38px;
    border-radius: 7px;
    padding: 0 8px;
    font-size: 14px;
    font-weight: 800;
  }

  .auth-modal-shell.is-login .auth-tab.active {
    background: rgba(89, 244, 119, 0.1);
    box-shadow: inset 0 0 0 1px rgba(89, 244, 119, 0.28);
  }

  .auth-form-panel {
    min-width: 0;
    min-height: 0;
    height: 100%;
    padding: 28px;
    background:
      linear-gradient(180deg, rgba(255, 255, 255, 0.025), transparent 22%),
      #181d29;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(89, 244, 119, 0.72) rgba(8, 12, 20, 0.28);
  }

  .auth-form-panel::-webkit-scrollbar {
    width: 5px;
  }

  .auth-form-panel::-webkit-scrollbar-track {
    background: rgba(8, 12, 20, 0.28);
    border-radius: 999px;
  }

  .auth-form-panel::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, rgba(112, 255, 139, 0.88), rgba(40, 217, 97, 0.68));
    border-radius: 999px;
  }

  .auth-modal-shell.is-register .auth-tab-row {
    margin-bottom: 18px;
  }

  .auth-modal-shell.is-register .auth-form {
    gap: 12px;
  }

  .auth-modal-shell.is-register .auth-form-grid {
    gap: 10px 12px;
  }

  .auth-modal-shell.is-register .form-group {
    gap: 6px;
  }

  .auth-form-transition {
    width: 100%;
    animation: authPanelIn 0.24s ease both;
  }

  .auth-tab-row {
    display: inline-flex;
    gap: 8px;
    padding: 4px;
    margin-bottom: 24px;
    border-radius: 10px;
    background: rgba(8, 12, 20, 0.36);
    border: 1px solid rgba(139, 177, 205, 0.08);
  }

  .auth-tab {
    height: 42px;
    min-width: 96px;
    border: 0;
    border-radius: 8px;
    padding: 0 18px;
    color: #aeb9c9;
    background: transparent;
    font-size: 15px;
    font-weight: 900;
    cursor: pointer;
    transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
  }

  .auth-tab.active {
    color: var(--crypto-green);
    background: rgba(203, 215, 255, 0.08);
    box-shadow: inset 0 0 0 1px rgba(89, 244, 119, 0.16);
  }

  .auth-switch-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .auth-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .auth-form-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px 12px;
  }

  .form-group {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 8px;
  }

  .form-group.full-span {
    grid-column: 1 / -1;
  }

  .form-label {
    color: #b8c3d1;
    font-size: 12px;
    line-height: 1.2;
    font-weight: 800;
  }

  .required {
    color: #ff6161;
  }

  .auth-field-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
  }

  .form-input,
  .form-select,
  .fa-code-input {
    width: 100%;
    min-width: 0;
    height: 42px;
    border: 1px solid rgba(139, 177, 205, 0.1);
    border-radius: 8px;
    color: #f3f7fb;
    background: rgba(9, 13, 23, 0.62);
    padding: 0 13px;
    font-size: 14px;
    font-weight: 600;
    outline: 0;
    transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
  }

  .form-select {
    appearance: none;
    background:
      linear-gradient(45deg, transparent 50%, #8fa2b8 50%),
      linear-gradient(135deg, #8fa2b8 50%, transparent 50%),
      rgba(9, 13, 23, 0.62);
    background-position:
      calc(100% - 17px) 18px,
      calc(100% - 12px) 18px,
      0 0;
    background-size: 5px 5px, 5px 5px, 100% 100%;
    background-repeat: no-repeat;
    padding-right: 34px;
  }

  .form-input::placeholder,
  .fa-code-input::placeholder {
    color: #748195;
  }

  .form-input:focus,
  .form-select:focus,
  .fa-code-input:focus {
    border-color: rgba(89, 244, 119, 0.74);
    background-color: rgba(9, 13, 23, 0.82);
    box-shadow: 0 0 0 3px rgba(89, 244, 119, 0.1);
  }

  .auth-inline-button {
    height: 42px;
    border: 1px solid rgba(89, 244, 119, 0.34);
    border-radius: 8px;
    padding: 0 12px;
    color: var(--crypto-green);
    background: rgba(89, 244, 119, 0.1);
    font-size: 12px;
    font-weight: 900;
    white-space: nowrap;
    cursor: pointer;
    transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease;
  }

  .auth-inline-button:hover:not(:disabled) {
    background: rgba(89, 244, 119, 0.18);
  }

  .auth-inline-button.success {
    color: #111820;
    border-color: rgba(89, 244, 119, 0.74);
    background: var(--crypto-green);
  }

  .auth-inline-button.error {
    color: #ff9b9b;
    border-color: rgba(255, 97, 97, 0.4);
    background: rgba(255, 97, 97, 0.08);
  }

  .auth-inline-button:disabled,
  .register-button:disabled {
    cursor: not-allowed;
    opacity: 0.68;
  }

  .auth-notice-backdrop {
    position: absolute;
    inset: 0;
    z-index: 8;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(5, 8, 14, 0.68);
    backdrop-filter: blur(5px);
    animation: authNoticeFade 0.16s ease both;
  }

  .auth-notice-panel {
    width: min(100%, 340px);
    border: 1px solid rgba(89, 244, 119, 0.22);
    border-radius: 10px;
    padding: 22px;
    text-align: center;
    background:
      radial-gradient(circle at 50% 0%, rgba(89, 244, 119, 0.14), transparent 38%),
      #101620;
    box-shadow:
      0 20px 50px rgba(0, 0, 0, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.06);
    animation: authNoticePop 0.18s ease both;
  }

  .auth-notice-panel strong {
    display: block;
    color: #f7fff9;
    font-size: 18px;
    line-height: 1.2;
    font-weight: 900;
  }

  .auth-notice-panel p {
    margin: 12px 0 18px;
    color: #b9c6d7;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 700;
  }

  .auth-notice-panel button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 120px;
    height: 40px;
    border: 0;
    border-radius: 8px;
    color: #101722;
    background: linear-gradient(135deg, #70ff8b, #28d961);
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
  }

  .error-message {
    color: #ff8484;
    font-size: 12px;
    font-weight: 600;
  }

  .auth-help-button,
  .auth-switch-button,
  .toggle-fa-code-input {
    width: max-content;
    border: 0;
    background: transparent;
    padding: 0;
    color: #98a7ba;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
  }

  .auth-help-button:hover,
  .auth-switch-button:hover,
  .toggle-fa-code-input:hover {
    color: var(--crypto-green);
  }

  .toggle-fa-code-input {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .toggle-fa-code-image {
    width: 7px;
    height: 6px;
    opacity: 0.75;
  }

  .required-message,
  .info-text {
    color: #94a3b8;
    font-size: 13px;
    line-height: 1.5;
    font-weight: 600;
  }

  .info-text-container {
    display: flex;
    align-items: center;
    min-height: 38px;
    border-radius: 8px;
    padding: 10px 12px;
    background: rgba(89, 244, 119, 0.06);
    border: 1px solid rgba(89, 244, 119, 0.12);
  }

  .info-text {
    margin: 0;
  }

  .register-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 46px;
    margin: 4px 0 0;
    border: 0;
    border-radius: 8px;
    color: #101722;
    background: linear-gradient(135deg, #70ff8b, #28d961);
    box-shadow:
      0 12px 22px rgba(22, 184, 87, 0.26),
      inset 0 1px 0 rgba(255, 255, 255, 0.44),
      inset 0 -3px 0 rgba(0, 0, 0, 0.2);
    font-size: 15px;
    font-weight: 900;
    cursor: pointer;
    transition: filter 0.18s ease, transform 0.18s ease;
  }

  .register-button:hover:not(:disabled) {
    filter: brightness(1.06);
    transform: translateY(-1px);
  }

  .auth-spinner {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    border-radius: 50%;
    border: 2px solid rgba(16, 23, 34, 0.24);
    border-top-color: #101722;
    animation: authSpin 0.75s linear infinite;
  }

  .auth-visual-panel {
    position: relative;
    min-height: 0;
    height: 100%;
    overflow: hidden;
    background: #0d1420;
  }

  .auth-visual-image {
    width: 100%;
    height: 100%;
    min-height: 0;
    display: block;
    object-fit: cover;
    filter: saturate(0.96) brightness(0.82);
  }

  .auth-visual-overlay {
    position: absolute;
    inset: 0;
    background:
      linear-gradient(90deg, rgba(24, 29, 41, 0.18), rgba(7, 11, 20, 0.08) 42%, rgba(7, 11, 20, 0.3)),
      linear-gradient(180deg, rgba(7, 11, 20, 0.3), rgba(7, 11, 20, 0.06) 45%, rgba(7, 11, 20, 0.88));
  }

  .auth-brand-logo {
    position: absolute;
    top: 34px;
    left: 50%;
    z-index: 2;
    max-width: 220px;
    max-height: 62px;
    object-fit: contain;
    transform: translateX(-50%);
    filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.42));
  }

  .auth-close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 3;
    width: 42px;
    height: 42px;
    border: 0;
    border-radius: 50%;
    background: rgba(22, 28, 42, 0.78);
    cursor: pointer;
    transition: background 0.18s ease, transform 0.18s ease;
  }

  .auth-close-button:hover {
    background: rgba(43, 52, 72, 0.9);
    transform: translateY(-1px);
  }

  .auth-close-button span::before,
  .auth-close-button span::after {
    content: "";
    position: absolute;
    top: 20px;
    left: 12px;
    width: 18px;
    height: 3px;
    border-radius: 999px;
    background: #c4cad6;
  }

  .auth-close-button span::before {
    transform: rotate(45deg);
  }

  .auth-close-button span::after {
    transform: rotate(-45deg);
  }

  .auth-visual-copy {
    position: absolute;
    left: 30px;
    right: 30px;
    bottom: 28px;
    z-index: 2;
    text-align: center;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.58);
  }

  .auth-visual-copy strong {
    display: block;
    color: #ffffff;
    font-size: 22px;
    line-height: 1.2;
    font-weight: 900;
  }

  .auth-visual-copy span,
  .auth-visual-copy p {
    color: rgba(239, 246, 255, 0.9);
    font-size: 13px;
    line-height: 1.55;
    font-weight: 700;
  }

  .auth-visual-copy span {
    display: block;
    margin-top: 8px;
  }

  .auth-visual-copy p {
    margin: 16px 0 0;
  }

  @keyframes authSpin {
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes authPanelIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes authNoticeFade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes authNoticePop {
    from {
      opacity: 0;
      transform: translateY(8px) scale(0.96);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @media (max-width: 920px) {
    .auth-modal-shell,
    .auth-modal-shell.is-register,
    .auth-modal-shell.is-anonymous {
      grid-template-columns: 1fr;
      height: auto;
      min-height: 0;
      max-height: 84vh;
    }

    .auth-modal-shell.is-login .auth-form-transition {
      max-width: none;
    }

    .auth-visual-panel {
      display: none;
    }

    .auth-form-panel {
      height: auto;
      max-height: 84vh;
      padding: 22px;
    }
  }

  @media (max-width: 620px) {
    .auth-header-button {
      height: 36px;
      padding: 0 13px;
      font-size: 13px;
    }

    .auth-header-login {
      margin-right: 6px;
    }

    .auth-header-anonymous {
      margin-left: 6px;
    }

    .auth-form-grid {
      grid-template-columns: 1fr;
    }

    .auth-tab {
      min-width: 94px;
      height: 39px;
      font-size: 14px;
    }

    .auth-field-row {
      grid-template-columns: 1fr;
    }

    .auth-inline-button {
      width: 100%;
    }
  }
`;
